'use client';

import { SearchBox } from 'react-instantsearch';

import { SortResultsModal as SortResultsModalWeb } from '@/components/atomic/atoms';
import { SORT_BY_ITEMS_BID_LIST } from '@/config/searchkit/bidList';
import { SORT_BY_ITEMS_ORDER_LIST } from '@/config/searchkit/orderList';

import ScopeSearchAttributeModalMobile from '@/components/atomic/atoms/searchkit/ScopeSearchAttributeModalMobile';
import { getPlaceholderTextForSearchBox } from '@/helpers/searchkit';

const sortByItemsMap = {
  bidList: SORT_BY_ITEMS_BID_LIST,
  orderList: SORT_BY_ITEMS_ORDER_LIST
};

const SearchBoxFilterMobile = ({
  searchableAttribute,
  searchAttributeLabelList = [],
  searchBoxPlaceholderText = 'Search',
  searchkitFormClass = 'searchkit-searchbox before:bg-searchkit-search-box-form',
  setSearchableAttribute,
  source
}) => (
  <div className='flex gap-2 h-10 md:h-13.5 mt-4'>
    <div className='flex justify-between border border-platinum rounded-full relative w-full md:w-54.7'>
      <div>
        <SearchBox
          {...{
            classNames: {
              form: `${searchkitFormClass} relative rounded-full h-8 md:h-12 left-3 w-full md:w-auto`,
              input: `w-84 md:w-51.5 shadow-none border-none h-9 md:h-12 ${searchAttributeLabelList.length > 0 ? '!pl-16' : '!pl-10'} relative`
            },
            placeholder:
              searchBoxPlaceholderText ||
              getPlaceholderTextForSearchBox({
                searchableAttribute,
                searchAttributeLabelList
              })
          }}
        />
      </div>
      {searchAttributeLabelList.length > 0 && (
        <ScopeSearchAttributeModalMobile
          {...{
            searchableAttribute,
            searchAttributeLabelList,
            setSearchableAttribute
          }}
        />
      )}
    </div>
    {source && (
      <SortResultsModalWeb
        {...{
          className: 'hidden md:flex',
          items: sortByItemsMap[source]
        }}
      />
    )}
  </div>
);

export default SearchBoxFilterMobile;
